import React from 'react';
import { Helmet } from 'react-helmet-async';
import URL from 'url-parse';

interface Props {
  imageUrl: string;
}

const CMSPreloadImage: React.FC<Props> = ({ imageUrl }) => {
  const cdnOrigin = new URL(imageUrl).origin.toString();
  const cdnUrl = cdnOrigin.endsWith('.com') ? cdnOrigin : '';

  return (
    <Helmet>
      {cdnUrl && <link rel="preconnect" href={cdnUrl} />}
      <link rel="preload" href={imageUrl} as="image" />
    </Helmet>
  );
};

export default CMSPreloadImage;
